import { useTranslationFromServerSide } from './useTranslation';
import React, { createContext } from 'react';

export const TranslationHookContext = createContext(null);

const TranslationHookProvider = ({ children }) => {
  return (
    <TranslationHookContext.Provider value={useTranslationFromServerSide}>
      {children}
    </TranslationHookContext.Provider>
  );
};

export default TranslationHookProvider;
